import { api } from './client';

export const mediaApi = {
  list: (eventId) =>
    api.get(`/events/${eventId}/media`).then((r) => r.data),

  upload: (eventId, file, onProgress) => {
    const form = new FormData();
    form.append('file', file);
    return api
      .post(`/events/${eventId}/media`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => {
          if (onProgress && e.total) {
            onProgress(Math.round((e.loaded * 100) / e.total));
          }
        },
      })
      .then((r) => r.data);
  },

  remove: (eventId, mediaId) =>
    api.delete(`/events/${eventId}/media/${mediaId}`).then((r) => r.data),

  reorder: (eventId, orderedIds) =>
    api.patch(`/events/${eventId}/media/reorder`, { orderedIds }).then((r) => r.data),


    getAudio: (eventId) =>
    api.get(`/events/${eventId}/media/audio`).then((r) => r.data),

  uploadAudio: (eventId, file, onProgress) => {
    const form = new FormData();
    form.append('file', file);
    return api
      .post(`/events/${eventId}/media/audio`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => {
          if (onProgress && e.total) {
            onProgress(Math.round((e.loaded * 100) / e.total));
          }
        },
      })
      .then((r) => r.data);
  },

  deleteAudio: (eventId) =>
    api.delete(`/events/${eventId}/media/audio`).then((r) => r.data),


    getCover: (eventId) =>
    api.get(`/events/${eventId}/media/cover`).then((r) => r.data),

  uploadCover: (eventId, file, onProgress) => {
    const form = new FormData();
    form.append('file', file);
    return api
      .post(`/events/${eventId}/media/cover`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => {
          if (onProgress && e.total) {
            onProgress(Math.round((e.loaded * 100) / e.total));
          }
        },
      })
      .then((r) => r.data);
  },

  deleteCover: (eventId) =>
    api.delete(`/events/${eventId}/media/cover`).then((r) => r.data),
  
};